module.exports = __webpack_public_path__ + "static/media/Euan.35b982cc.jpg";